export default "__VITE_ASSET__8c6b72b2__"